import React from 'react';
import './CheckoutProduct.css';
import StarRateIcon from '@material-ui/icons/StarRate';
import { useStateValue } from './StateProvider';
import Fade from 'react-reveal/Fade';

function CheckoutProduct({id, image, title, price, rating}) {
    const [{basket}, dispatch] = useStateValue();

    const removeFromBasket = () => {
        dispatch({
            type: 'REMOVE_FROM_BASKET',
            id: id,
        })
    }

    return (
        <div className="checkoutProduct">
            <Fade bottom>
            <img className="checkoutProduct_image" src={image} />
            <div className="checkoutProduct_info">
                <p className="checoutProduct_title">{title}</p>
                <p className="checkoutProduct_price"><small>ksh.</small><strong>{price}</strong></p>
                <p className="checkoutProduct_rating">
                    {Array(rating)
                    .fill()
                    .map(() => (
                        <span><StarRateIcon/></span>
                    ))}
                </p>
                <button onClick={removeFromBasket}>Remove from basket</button>
                
            </div>

            </Fade>
            
        </div>
    )
}

export default CheckoutProduct;
